var _path;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgHugBrush1(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "20 20 1538 834",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "#000",
    strokeLinecap: "round",
    strokeWidth: 150,
    d: "M75.746 287.103C180.584 249.855 419.495 90.036 439.722 109.53c32.436 31.263-352.796 461.439-322.983 508.959 41.277 65.791 725.468-583.99 775.157-541.472 49.69 42.517-438.51 507.708-414.907 610.25 6.731 29.243 573.911-467.066 616.151-445.808 8.32 4.19-269.567 410.794-214.908 533.344 22.318 50.04 524.228-503.401 589.378-503.401 65.14 0-90.49 328.574-217.32 487.11"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHugBrush1);
export default __webpack_public_path__ + "static/media/hug-brush-1.bdb3fd07a28addac6ed47d280b4314f2.svg";
export { ForwardRef as ReactComponent };